"use client";

import React from "react";
import Image from "next/image";
import Tilt from "react-parallax-tilt";
import { FormattedMessage } from "react-intl";

import { uuid } from "@/utils";

import mainScreenPost from "@/assets/images/media/main-screen-post.png";
import dashboardClickOrange from "@/assets/images/media/dashboard-click-orange.png";
import dashboardVisitorsOrange from "@/assets/images/media/dashboard-visitors-orange.png";

import StartCustomDomain from "../StartCustomDomain";

const Hero = () => (
  <section id="home" className="pt-[165px]">
    <div className="container lg:max-w-[1305px] lg:px-10">
      <div className="flex flex-wrap items-center -mx-4">
        <div className="w-full px-4 lg:w-7/12">
          <div className="wow fadeInUp mb-12 lg:mb-0 lg:max-w-[570px]" data-wow-delay=".2s">
            <span className="mb-5 block text-lg font-medium leading-tight text-black sm:text-[22px] xl:text-[22px]">
              <FormattedMessage
                id="home-page-hero-sub-title"
              />
            </span>
            <h1 className="mb-6 text-3xl font-bold leading-tight text-black sm:text-[40px] md:text-[50px] lg:text-[42px] xl:text-[50px]">
              <FormattedMessage
                id="home-page-hero-title"
                values={{
                  span: (...chunks) => (
                    <span
                      key={uuid()}
                      className="inline text-transparent bg-gradient-1 bg-clip-text"
                    >
                      {React.Children.toArray(chunks)}
                    </span>
                  ),
                  br: () => <br key={uuid()} />,
                }}
              />
            </h1>
            <p className="mb-10 max-w-[475px] text-base leading-relaxed text-body">
              <FormattedMessage
                id="home-page-hero-description"
              />
            </p>

            <div className="flex flex-wrap items-center">
              <StartCustomDomain />
            </div>
          </div>
        </div>

        <div className="w-full px-4 lg:w-5/12">
          <div
            className="relative z-10 mx-auto w-full max-w-[530px] lg:mr-0"
            data-wow-delay=".3s"
          >
            <Tilt>
              <Image
                priority={true}
                src={mainScreenPost}
                width={300}
                height={800}
                alt="Downfor profile page example"
                title="Downfor profile page example"
                className="max-w-full mx-auto"
              />
            </Tilt>
            <div
              className="absolute top-0 left-0 right-0 w-full rounded-full max-auto -z-10 aspect-square bg-gradient-1"
              style={{
                alignSelf: "anchor-center"
              }}
            ></div>
            <div className="absolute right-0 top-20">
              <Image
                src={dashboardClickOrange}
                width={120}
                height={40}
                alt="Downfor profile page example slicks"
                title="Downfor profile page example clicks"
              />
            </div>
            <div className="absolute left-0 bottom-20">
              <Image
                src={dashboardVisitorsOrange}
                width={120}
                height={40}
                alt="Downfor profile page example dasboard"
                title="Downfor profile page example dasboard"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;